import type { ApiResponse } from "libs/apiClient";
import client from "libs/client";
import { buildVideoUploadsQueryString, type VideoUploadsQueryParams } from "./buildVideoUploadsQueryString";
import { videoUploadsPageSchema, type VideoUploadsPage } from "./videoUploadsPageSchema";

export type { VideoUploadsQueryParams } from "./buildVideoUploadsQueryString";

export async function fetchVideoUploads(
	params: VideoUploadsQueryParams,
	signal?: AbortSignal,
): Promise<ApiResponse<VideoUploadsPage>> {
	// Route through AdminApiClient's wretch so the shared 401 catcher can send the
	// user to /login. Do not use getVideoUploads.query(): its generated Zod enums
	// reject VIDEO_DELETED / CANCELLED rows and sort fields such as apiStatus.
	const response = await client.http
		.options({ signal })
		.url(`/admin/video-uploads/${params.preset}`)
		.query(buildVideoUploadsQueryString(params))
		.get()
		.res();

	if (response.status !== 200) {
		throw Object.assign(new Error("Failed to fetch video uploads"), { status: response.status });
	}

	const json: unknown = await response.json();

	return {
		status: response.status,
		data: videoUploadsPageSchema.parse(json),
		headers: response.headers,
		url: response.url,
	};
}
